import { Stack, Shelf, Text } from "@chaser/components";
import { toCurrency } from "../../../../util";
import styles from "../AddonOption.module.scss";

const PriceSummary = ({
  resolvedQuantity,
  isVolume,
  currentTier,
  price,
  currency,
  currentSavingsPercent,
  calculatedPrice,
  period,
}) => {
  return (
    <Shelf
      className={styles.volumeSummaryCard}
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack gap="xsmall">
        <Text color="Mid Neutral 1" fontSize="small">
          {resolvedQuantity} x{" "}
          {toCurrency(
            ((isVolume ? currentTier?.price || 0 : price) || 0) / 100,
            currency,
          )}
        </Text>
        {isVolume && currentSavingsPercent > 0 && (
          <Text
            fontSize="xxsmall"
            fontWeight="bold"
            color="Orange AA"
            className={styles.volumeSummarySavingsText}
          >
            SAVING {currentSavingsPercent}% VS STARTER TIER
          </Text>
        )}
      </Stack>
      <Stack gap="small" alignItems="flex-end">
        <Text fontSize="heading.2" fontWeight="bold">
          {calculatedPrice}
        </Text>
        <Text color="Mid Neutral 1" fontSize="small">
          per {period}
        </Text>
      </Stack>
    </Shelf>
  );
};

export default PriceSummary;
